<template>
  <div>
    <v-btn :to="{ name : 'calendar' }" color="none" icon>
      <v-icon>arrow_left</v-icon>
    </v-btn>

    <div v-if="loading">
      <v-progress-linear color="primary" indeterminate></v-progress-linear>
    </div>

    <div v-else>
      <v-layout wrap>
        <v-flex lg8 md8 sm12 xs12>
          <v-checkbox v-model="showDeleted" :label="$t('calendar.history.show_only_deleted_events')" @change="filter"/>
        </v-flex>
        <v-flex lg4 md4 sm12 xs12>
          <v-text-field v-model="searchText" :label="$t('data-table.search')" @change="filter"></v-text-field>
        </v-flex>
      </v-layout>

      <v-data-table :headers=" headers" :items="calednarHistory" :pagination.sync="pagination" class="elevation-10">
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.scheduledAt }}</td>
          <td>{{ props.item.created_by_full_name }}</td>
          <td>{{ props.item.updated_by_full_name }}</td>
          <td>{{ props.item.updated_at }}</td>
          <td>{{ props.item.deleted == 0 ? "NIE" : "TAK" }}</td>
        </template>
      </v-data-table>
    </div>

  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"

export default {
  name: "HistoryAll",
  data() {
    return {
      calednarHistory: [],
      allCalednarHistory: [],
      loading: true,
      searchText: '',
      showDeleted: false,
      products: [],
      users: [],
      headers: [
        {
          text: 'ID',
          value: "id",
        },
        {
          text: this.$t('calendar.history.name'),
          value: 'title'
        },
        {
          text: this.$t('calendar.history.description'),
          value: 'description'
        },
        {
          text: this.$t('calendar.history.scheduled_at'),
          value: 'scheduledAt'
        },
        {
          text: this.$t('calendar.history.created_by'),
          value: 'created_by'
        },
        {
          text: this.$t('calendar.history.modified_by'),
          value: 'modified_by'
        },
        {
          text: this.$t('calendar.history.updated_at'),
          value: 'updated_at'
        },
        {
          text: this.$t('calendar.history.deleted'),
          value: 'active'
        },
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25 // -1 for All",
      }
    }
  },
  created() {
    this.loading = true
    let users = this.$http.get('users')
    let history = this.$http.get(`calendar/history`)

    Promise.all([history, users]).then(data => {
      this.users = data[1].data
      this.calednarHistory = data[0].data.map(this.expandCalendarHistory)
      this.allCalednarHistory = this.calednarHistory.map(el => el)
      this.loading = false
    }).catch(() => {
      Messenger.emitError(this.$t('calendar.history.download_error'))
    })
  },
  methods: {
    getUser(id) {
      let user = this.users ? this.users.find(el => el.id == id) : false
      if (user) {
        return user.name + " " + user.surname
      }
      return ""
    },
    filter() {
      let text = this.searchText
      if (text == "") {
        this.calednarHistory = this.allCalednarHistory.filter(history => this.showDeleted ? history.deleted == 1 : true)
      }

      text = text.toLowerCase()
      this.calednarHistory = this.allCalednarHistory.filter(history =>
        history.created_by_full_name.toLowerCase().includes(text) || history.updated_by_full_name.toLowerCase().includes(text)
          || history.title.toLowerCase().includes(text) || history.description.toLowerCase().includes(text)
          || history.scheduledAt.includes(text) || history.updated_at.includes(text)
      ).filter(history => this.showDeleted ? history.deleted == 1 : true)
    },
    expandCalendarHistory(ch) {
      ch.created_by_full_name = this.getUser(ch.created_by)
      ch.updated_by_full_name = this.getUser(ch.updated_by)
      return ch
    }
  },
}
</script>

<style scoped>

</style>